const GET_RESERVATIONS_ERROR_TEXT = "Une erreur est survenue lors du chargement des réservations.";
const ADD_RESERVATION_ERROR_TEXT = "Une erreur est survenue lors de l'ajout de la réservation.";
const DELETE_RESERVATION_ERROR_TEXT = "Une erreur est survenue lors de la suppression de la réservation.";
const UPDATE_RESERVATION_ERROR_TEXT = "Une erreur est survenue lors de la modification de la réservation.";
const CONFIRM_RESERVATION_ERROR_TEXT = "Une erreur est survenue lors de la confirmation de la réservation.";
const CANCEL_RESERVATION_ERROR_TEXT = "Une erreur est survenue lors de l'annulation de la réservation.";

export const GET_RESERVATIONS_ERROR = GET_RESERVATIONS_ERROR_TEXT;
export const ADD_RESERVATION_ERROR = ADD_RESERVATION_ERROR_TEXT;
export const DELETE_RESERVATION_ERROR = DELETE_RESERVATION_ERROR_TEXT;
export const UPDATE_RESERVATION_ERROR = UPDATE_RESERVATION_ERROR_TEXT;
export const CONFIRM_RESERVATION_ERROR = CONFIRM_RESERVATION_ERROR_TEXT;
export const CANCEL_RESERVATION_ERROR = CANCEL_RESERVATION_ERROR_TEXT;

export const GET_RESERVATION_PAYMENT_ERROR = "Une erreur est survenue lors de la récupération du paiement."


// WEBPACK FOOTER //
// ./src/errors/reservations.js